import { DashboardCardLinkButton } from '../../storageDashboard/DashboardCardLinkButton';
import type { PatientTrackingDashboardSummary } from './patientTrackingDashboardTypes';
import { patientStatusLabel } from './patientTrackingDashboardFormatters';

interface PharmacyOpenIssuesCardProps {
  summary: PatientTrackingDashboardSummary;
  openHref: string;
}

export function PharmacyOpenIssuesCard({ summary, openHref }: PharmacyOpenIssuesCardProps) {
  const statusPills = [
    { key: 'pending', label: patientStatusLabel('Pending'), count: summary.statusCounts.pending },
    { key: 'followUp', label: patientStatusLabel('FollowUp'), count: summary.statusCounts.followUp },
    { key: 'onHold', label: patientStatusLabel('OnHold'), count: summary.statusCounts.onHold },
    { key: 'reviewed', label: patientStatusLabel('Reviewed'), count: summary.statusCounts.reviewed },
    { key: 'sent', label: patientStatusLabel('Sent'), count: summary.statusCounts.sent }
  ].filter((x) => x.count > 0);

  return (
    <section className="dashboard-card dashboard-card--pharmacy-open">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Open Issues</h3>
          <p>Active patient communication tracker issues</p>
        </div>
        <DashboardCardLinkButton text="Open Tracker" href={openHref} />
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.openIssueCount}</span>
          <span className="dashboard-kpi__label">Open issues</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.patientsWithOpenIssues}</span>
          <span className="dashboard-kpi__label">Patients with open issues</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.totalPatients}</span>
          <span className="dashboard-kpi__label">Total patients</span>
        </div>
      </div>

      {statusPills.length > 0 ? (
        <div className="dashboard-type-row" aria-label="Open issues by status">
          {statusPills.map((pill) => (
            <span key={pill.key} className="dashboard-pill">
              {pill.label}: {pill.count}
            </span>
          ))}
        </div>
      ) : (
        <p className="dashboard-empty">No open issues right now.</p>
      )}
    </section>
  );
}
